import { clamp } from "@utils/utils";

export function CompressorOutputDb(
  inputDb: number,
  threshold: number,
  ratio: number,
  knee: number,
): number {
  const halfKnee = knee / 2;
  if (inputDb < threshold - halfKnee) return inputDb;
  if (knee > 0 && inputDb <= threshold + halfKnee) {
    const overKnee = inputDb - threshold + halfKnee;
    return inputDb + ((1 / ratio - 1) * overKnee * overKnee) / (2 * knee);
  }
  return threshold + (inputDb - threshold) / ratio;
}

export function WaveshaperOutput(inputNorm: number, drive: number, curveAmount: number): number {
  const driveGain = 1 + drive * 10;
  const saturation = driveGain * (1 + curveAmount * 4);
  const satMax = Math.tanh(saturation);
  if (satMax < 0.0001) return inputNorm;
  return clamp(Math.tanh(inputNorm * saturation) / satMax, -1, 1);
}
